<template>
  <div class="line-unitaire">
    <!-- Nom du produit + suppression -->
    <div class="row">
      <div class="col s10">
        <h2>{{product.name}}</h2>
      </div>
      <div class="col s2 right-align">
        <i class="material-icons close-icon" @click="remove">close</i>
      </div>
    </div>

    <div class="row">
      <div class="col s6">
        <select-number v-bind:max="getStock" v-bind:propQuantity="product.quantity" v-on:change="editQuantity"
        label="Quantité pièce"></select-number>
      </div>

      <div class="col s6">
        <info
          id="price-unit"
          label="Prix pièce"
          :value="(product.price * product.coefficient).toFixed(2)+'€'"
        ></info>
      </div>
    </div>

    <div class="row">
      <div class="col s6">
        <info value="TOTAL"></info>
      </div>
      <div class="col s6">
        <info :value="(product.price * product.coefficient * product.quantity).toFixed(2)+'€'"></info>
      </div>
    </div>
  </div>
</template>

<script>
import Info from "@/components/Product/Info.vue";
import SelectNumber from "@/components/SelectNumber.vue";

export default {
  props: ["product"],
  methods: {
    editQuantity: function(quantity) {
      this.$store.commit("editQuantity", {id:this.product.id, quantity:quantity});
    },
    remove: function() {
      this.$store.commit("removeProduct", this.product.id);
    }
  },
  computed: {
    /* Retourne le stock max du produit, pour l'input quantity */
    getStock: function() {
      return (this.product.stock / this.product.coefficient);
    }
  },
  components: {
    Info,
    SelectNumber
  }
};
</script>

<style scoped>
h2 {
  font-size: 1.3em;
  margin: 0;
}
.line-unitaire {
  padding: 1em 1em 0 1em;
  background-color: #eeeeee;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  margin-bottom: 1.5em;
}

.close-icon {
  border: 2px solid rgb(104, 104, 104);
  border-radius: 50%;
}

label {
  display: block;
  text-align: center;
}

.number-button {
  float: left;
  display: block;
  width: 100%;
  height: 35px;
  text-align: center;
  font-size: 100%;
  border: 2px black solid;
  padding: 0.2em;
  line-height: 25px;
}
</style>